<template>
<div id="app">
    <el-header>
        <navigation v-if="isAuthenticated" />
    </el-header>
    <el-main>
        <div class="main-container">
            <center-container>
                <router-view />
            </center-container>
        </div>
    </el-main>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CenterContainer from "@/components/lib/center-container";
import Navigation from "@/components/navigation";
import { ONLINE, OFFLINE, AUTH_LOGOUT, AUTH_RENEW } from "@/store/actions/auth";
import router from "@/router";

export default {
  name: "app",
  computed: {
    ...mapGetters(["isAuthenticated", "authStatus", "isOnline"])
  },

  components: {
    Navigation,
    CenterContainer
  },

  created: function() {
    axios.interceptors.response.use(
      response => {
        return response;
      },
      function(error) {
        if (error.response) {
          if (error.response.status === 401) {
            console.log("unauthorized, logging out ...");
            this.$store.dispatch(AUTH_LOGOUT);
            router.replace("/login");
          }
        }
        return Promise.reject(error);
      }
    );
  },

  mounted() {
    window.addEventListener("load", () => {
      // 1st, we set the correct status when the page loads
      navigator.onLine
        ? this.$store.commit(ONLINE)
        : this.$store.commit(OFFLINE);

      // now we listen for network status changes
      window.addEventListener("online", () => {
        this.$store.commit(ONLINE);
      });

      window.addEventListener("offline", () => {
        this.$store.commit(OFFLINE);
      });
    });
  },

  watch: {
    isOnline(newVal) {
      // when online status changed, automatically renew token.
      if (newVal) this.$store.dispatch(AUTH_RENEW);
    }
  }
};
</script>

<style>
body {
  font-family: "Myriad Pro", "Helvetica Neue", Helvetica, "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  background-color: #fefefe;
}
</style>

<style scoped>
.main-container {
  /* min-height: calc(100vh - 70px); */
}
</style>
